module.exports = __webpack_public_path__ + "img/illu_04.159c9236.svg";